import { Box, Typography } from "@mui/material";
import React from "react";
import { CustomerInterface } from "../../Objects/Customer";

export interface CustomerNameProps {
    customerData: CustomerInterface
}

const CustomerName: React.FC<CustomerNameProps> = ({
    customerData
}) => {
    return (
        <Box>
            <Typography variant="caption">{customerData.ctm_pronunciation1} {customerData.ctm_pronunciation2}</Typography>
            <Typography variant="h6" sx={{marginTop: "-0.3em"}}>{customerData.ctm_name1} {customerData.ctm_name2}</Typography>
        </Box>
    );
}

export default CustomerName